"use client";

import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";

export function HeroSection() {
  return (
    <section className="py-6 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* Grande bannière gauche */}
          <div className="md:col-span-2 relative rounded-2xl overflow-hidden bg-gradient-to-r from-secondary/90 to-secondary/70 min-h-[280px]">
            <Image
              src="/hero-bg.png"
              alt="Matériel de chantier"
              fill
              className="object-cover mix-blend-overlay opacity-60"
            />
            <div className="relative z-10 p-6 md:p-8 flex flex-col justify-center h-full">
              <div className="max-w-md">
                <h1 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight">
                  Louez et achetez le matériel idéal pour vos chantiers en 1 seul clic.
                </h1>
                <Button size="lg" className="rounded-full">
                  Trouver mon matériel
                </Button>
              </div>
              {/* Logo Toolouer */}
              <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8">
                <Image
                  src="/e59ec9a9_logo2.18b3d9b3.svg"
                  alt="Toolouer"
                  width={180}
                  height={50}
                  className="opacity-90"
                />
              </div>
            </div>
          </div>

          {/* Petite bannière droite - Livraison */}
          <div className="relative rounded-2xl overflow-hidden bg-gray-400 min-h-[280px]">
            <Image
              src="/livraison-bg.png"
              alt="Livraison"
              fill
              className="object-cover"
            />
            <div className="absolute inset-0 bg-black/20" />
            <div className="relative z-10 p-6 flex flex-col justify-center h-full">
              <h2 className="text-xl md:text-2xl font-bold text-white mb-2">
                Livraison offerte dès 150€ d&apos;achat*
              </h2>
              <Link href="/boutique/toolmatos">
                <Button className="rounded-full w-fit mt-2 bg-primary text-black hover:bg-primary/90">
                  Découvrir l&apos;offre
                </Button>
              </Link>
              <p className="text-white/70 text-xs mt-4">*Boutique Toolmatos</p>
            </div>
          </div>

        </div>

        {/* Bannières du bas - 1/2 1/2 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          {/* Bannière bas gauche - Code promo */}
          <div className="relative rounded-2xl overflow-hidden bg-secondary min-h-[180px]">
            <div className="relative z-10 p-6 pr-0 flex items-center h-full">
              <div className="flex-1 max-w-[55%]">
                <p className="text-white text-lg md:text-xl font-bold">
                  <span className="text-primary">50€ offerts</span> sur vos 3 premiers achats de +300€ en entrant le code :
                </p>
                <p className="text-primary text-2xl font-bold mt-2">BIENVENUE</p>
              </div>
              {/* Cercle vert clair - position originale du site */}
              <div
                className="absolute w-[245px] h-[245px] rounded-full z-0"
                style={{ right: '-30px', bottom: '-90px', backgroundColor: '#90bdaf' }}
              />
              {/* Perceuse - touche le bas */}
              <div className="absolute right-4 bottom-0 w-[40%] h-[90%] z-10">
                <Image
                  src="/perceuse-makita.png"
                  alt="Perceuse Makita"
                  fill
                  className="object-contain object-bottom"
                />
              </div>
            </div>
          </div>

          {/* Bannière bas droite - Location ponçage */}
          <div className="relative rounded-2xl overflow-hidden bg-primary min-h-[180px]">
            <div className="relative z-10 p-6 flex items-center h-full">
              <div className="flex-1 max-w-[55%]">
                <h2 className="text-xl md:text-2xl font-bold text-black">
                  Louez ma machine de ponçage
                </h2>
                <p className="text-black/70 text-lg mt-1">
                  à partir de <span className="font-bold text-2xl text-black">5€/jour</span>
                </p>
              </div>
              {/* Cercle jaune clair - position originale du site */}
              <div
                className="absolute w-[245px] h-[245px] rounded-full z-0"
                style={{ right: '-30px', bottom: '-90px', backgroundColor: '#ffdd94' }}
              />
              {/* Ponceuse - taille 100% naturelle */}
              <div className="absolute right-4 top-1/2 -translate-y-1/2 z-10">
                <Image
                  src="/ponceuse.png"
                  alt="Machine de ponçage"
                  width={200}
                  height={200}
                  className="object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
